import { $CombinedState, AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import { AppState } from '@modules';

// createAsyncActions

type ThenArg<T> = T extends PromiseLike<infer U> ? U : T;
type ThunkApi = Parameters<Parameters<typeof createAsyncThunk>[1]>[1];
export type CustomThunkApiType = { getState: () => AppState } & ThunkApi;

export type CreateAsyncActions = <
  T extends keyof Omit<AppState, typeof $CombinedState>,
  Callbacks extends {
    [key in string]: (data: any, thunkApi: CustomThunkApiType) => any;
  }
>(
  name: T,
  callbacks: Callbacks
) => {
  [key in keyof Callbacks]: AsyncThunk<
    ThenArg<ReturnType<Callbacks[key]>>,
    Parameters<Callbacks[key]>[0],
    ThunkApi
  >;
};

const catchError = <T, K>(callback: (data: T, thunkApi: CustomThunkApiType) => Promise<K>) => {
  return (data: T, thunkApi: ThunkApi) =>
    callback(data, thunkApi as CustomThunkApiType).catch(err =>
      thunkApi.rejectWithValue(err?.response?.data || err)
    );
};

export const createAsyncActions: CreateAsyncActions = (name, callbacks) =>
  Object.entries(callbacks).reduce<any>((acc, [nameAction, callback]) => {
    acc[nameAction] = createAsyncThunk(`${name}/${nameAction}`, catchError(callback));
    return acc;
  }, {});

// createActions

type CreateActions = <
  Callbacks extends {
    [key in string]: (name: string) => void;
  }
>(
  name: string,
  callbacks: Callbacks
) => { [key in keyof Callbacks]: ReturnType<Callbacks[key]> };

export const createActions: CreateActions = (name, callbacks) => {
  return Object.entries(callbacks).reduce<any>((acc, [nameAction, callback]) => {
    acc[nameAction] = callback(`${name}/${nameAction}`);
    return acc;
  }, {});
};

export type WritableStore<T> = {
  -readonly [K in keyof T]: T[K];
};
